import React, { useState, useContext } from 'react';
import axios from '../../../../../axios/index';

// context
import { UserContext } from '../../../../Context/UserContextProvider';

import Modal from 'react-bootstrap/Modal';

import ReminderPortalDatePicker from '../../../Notes/Reminder/ReminderPortalDatePicker';
import ReminderTimePicker from '../../../Notes/Reminder/ReminderTimePicker';
import Checkbox from '@mui/material/Checkbox';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// styles
import ModalStyles from "../../../DashboardReuseAbleComponents/Modal.module.css"
import styles from "../../../Notes/Reminder/ReminderPortal.module.css"
import Dstyles from "../../../DashboardFileManagement/DashboardFileManagement.module.css"

export default function ReminderModal(props) {
    const { userToken } = useContext(UserContext);
    const [error, setError] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)
    const [addedReminderData, setAddedReminderData] = useState({
        title: "",
        hourValue: "",
        dateValue: ""
    })

    const [reminderSendWay, setReminderSendWay] = useState(
        [
            { id: 1, name: "پروفایل کاربری", status: false },
            { id: 2, name: "مرورگر شخصی", status: false },
            { id: 3, name: "پیامک", status: false },
            { id: 4, name: "همه موارد", status: false },
        ]
    )

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <ToastContainer
                position="top-right"
                autoClose={9000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            تنظیم یادآور
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body dir='rtl'>
                    <div className='w-100 d-flex flex-column align-items-center justify-content-center py-2 flex-wrap'>
                        <div className={`w-100 d-flex align-items-center justify-content-center my-4 ${styles.text_bold}`}>
                            روز و ساعت یادآور را انتخاب کنید
                        </div>

                        <div className={`w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap pt-0 px-3 mb-4`}>
                            <div className={`d-flex align-items-start justify-content-center flex-column my-3 ${styles.input_container1}`}>
                                <div className={`mb-3 ${styles.input_top_title}`}>
                                    عنوان یادآور
                                </div>
                                <input
                                    className={styles.input}
                                    type="text"
                                    name="title"
                                    value={addedReminderData.title}
                                    onChange={changeHandler}
                                />
                            </div>
                            <ReminderPortalDatePicker data={addedReminderData.dateValue} setData={setAddedReminderData} />
                        </div>

                        <div className='w-100 d-flex align-items-center justify-content-between pt-0 px-3 mb-5 mx-2'>
                            <ReminderTimePicker data={addedReminderData.hourValue} setData={setAddedReminderData} />
                        </div>

                        <div className="w-100 d-flex flex-column align-items-start justify-content-center my-3">
                            <div className={`mb-3 ${styles.input_header}`}>
                                نوع ارسال یادآور
                            </div>
                            <div className='w-100 d-flex align-items-center justify-content-between px-4 flex-wrap'>
                                {reminderSendWay.map((item) => (
                                    <div key={item.id} className='d-flex align-items-center justify-content-center'>
                                        <Checkbox
                                            checked={item.status}
                                            onClick={() => checkBoxHandler(item, item.id)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            size="small"
                                        />
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 flex-column d-flex justify-content-center align-items-center mb-3'>
                        {btnLoader ? (
                            <div className={Dstyles.btn_loader_container}>
                                <div className={Dstyles.btn_spinner}></div>
                            </div>
                        ) : (
                            <div div className={`d-flex align-items-center justify-content-center me-3 ${ModalStyles.filled_btn}`} onClick={clickHandler}>
                                ذخیره
                            </div>
                        )}
                        {error
                            &&
                            <span className='text-danger mt-4'>لطفا تمام فیلد هارا پر کنید!</span>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    function changeHandler(event) {
        setAddedReminderData((prev) => {
            return { ...prev, [event.target.name]: event.target.value };
        });
    };

    function checkBoxHandler(checkBoxData, id) {
        const updatedList = reminderSendWay.map((item) => {
                if (item.id != id){
                    return { id: item.id, name: item.name, status: false }
                }else{
                    return { id: checkBoxData.id, name: checkBoxData.name, status: true }
                }
            });
        // Check if all statuses from 1 to 3 are true
        /*const allTrue = updatedList.slice(0, 3).every((item) => item.status);

        // Update status of fourth item if all statuses from 1 to 3 are true
        if (allTrue) {
            updatedList[3].status = true;
        } else {
            updatedList[3].status = false;
        }*/

        setReminderSendWay(updatedList);
    }

    async function clickHandler() {
        try {
            if (addedReminderData.dateValue === "" | addedReminderData.hourValue === "" | addedReminderData.title === "") {
                setError(true)
            } else {
                notify("درحال تنظیم یادآور", "success")
                setBtnLoader(true)
                const RminderTitle = addedReminderData.title
                const RminderReminderDate = `${addedReminderData.dateValue.year}/${addedReminderData.dateValue.month.number}/${addedReminderData.dateValue.day}`
                const RminderReminderTime = `${addedReminderData.hourValue.hour}:${addedReminderData.hourValue.minute}`

                var data = new FormData();
                data.append('ObjectId', props.id);
                data.append('ReminderFor', 1);
                data.append('Title', RminderTitle);
                data.append('ReminderDate', RminderReminderDate);
                data.append('ReminderTime', RminderReminderTime);
                if (reminderSendWay?.find(item => item.id === 4 && item.status === true)) {
                    data.append('ReminderDeliver', 4);
                    // console.log("object")
                } else {
                    for (const ReminderDeliver of reminderSendWay) {
                        if (!ReminderDeliver.status){
                            continue;
                        }
                        data.append('DeliverMethod', ReminderDeliver.id);
                    }
                    // console.log("oneee")
                }

                const apiData = await axios.post(
                    "Reminder",
                    data,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                // console.log(apiData)
                notify("یادآور با موفقیت تنظیم شد", "success")
                props.onHide()
                window.location.reload();
            }
        } catch (error) {
            notify("خطای سرور", "error")
        }
    };


}
